
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden, SET_selectedRoommate } from "../../reducers/uiReducer";

import moment from "moment"

const RoommateList: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    const clickSelectRoommate = (e: React.MouseEvent, roommateState: number) => {
        e.preventDefault();
        
        if (uiData.selectedRoommate !== roommateState) {
            dispatch(SET_selectedRoommate(roommateState));
        }
    };

    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                flexDirection: "column",
                textAlign: "left",
                //backgroundColor: "yellow",
                gap: "5vh",
                //padding: "3vh 0",
                color: "rgba(255, 255, 255, 0.9)",
            }}
        >
         
            <div
                style={{
                    width: "100%",
                    height: "auto",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    fontSize: "1.75vh",
                    boxSizing: "border-box",
                    fontWeight: "bold",
                    padding: "2vh",
                    borderRadius: "0.5vh",
                    border: "0.2vh solid rgba(90, 90, 90, 0.8)",
                    backgroundColor: "rgba(60, 60, 60, 0.8)",
                    color: "rgba(200, 200, 200, 1)",
                    gap: "2vh",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-evenly",
                        alignItems: "center",
                        boxSizing: "border-box",
                        //backgroundColor: "gray",
                      
                    }}
                >
                    <div
                        className="itemDiv"
                    >
                        CITIZEN NAME
                    </div>
                    <div
                        className="itemDiv"
                    >
                        CITIZEN ID
                    </div>
                    <div
                       className="itemDiv"
                    >
                        LAST ONLINE
                    </div>
                    <div
                        className="itemDiv"
                    >
                        DATE ADDED TO HOME
                    </div>
                </div>

                {hardmoneyData.roommates
                    .filter(roommate => roommate.UserStateID !== playerData.UserState)
                    .map((roommateData, index) => {
                        const numericTimeInSeconds = moment(roommateData.dateAdded).unix();
                        const formattedDateAdded = moment.unix(numericTimeInSeconds).format("M/D/YYYY");

                        const numericLastOnlineTimeInSeconds = moment(roommateData.lastOnline).unix();
                        //sconst formattedLastOnline = moment.unix(numericLastOnlineTimeInSeconds).format("h:mm A M/D/YYYY");
                        const formattedLastOnline = moment.unix(numericLastOnlineTimeInSeconds).fromNow();
                        
                        return (
                        <div
                            key={index}
                            onClick={e => clickSelectRoommate(e, roommateData.UserStateID)}
                            className = "hoverColorBG"
                            style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "center",
                                boxSizing: "border-box",
                                backgroundColor: uiData.selectedRoommate === roommateData.UserStateID && `rgba(${uiData.schemeColor}, 0.1)`,
                                //borderRadius: "0.25vh",
                                padding: "1vh 0",
                                cursor: "pointer",
                                transition: "background-color 0.25s ease",
                                '--scheme-color': `rgba(${uiData.schemeColor}, 0.2)`,      
                            }  as React.CSSProperties} 
                        >
                            <div
                                className="itemDiv"
                            >
                                {roommateData.playerFirstName} {roommateData.playerLastName}
                            </div>
                            <div
                                className="itemDiv"
                            >
                                {roommateData.UserStateID}
                            </div>
                            <div
                            className="itemDiv"
                            >
                                {formattedLastOnline}
                            </div>
                            <div
                                className="itemDiv"
                            >
                                {formattedDateAdded}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RoommateList;
